module.exports = __webpack_public_path__ + "img/1-23-5.502ab013.png";